if (!customElements.get('fc-product-tabs')) {
  customElements.define(
    'fc-product-tabs',
    class FcProductTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.tabs = this.querySelectorAll('.fc-product-tabs__tab');
        this.panels = this.querySelectorAll('.fc-product-tabs__panel');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.switchTab(tab));
        });
      }

      switchTab(selectedTab) {
        const index = selectedTab.dataset.tabIndex;

        this.tabs.forEach((tab) => {
          const isActive = tab === selectedTab;
          tab.classList.toggle('fc-product-tabs__tab--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel, i) => {
          const isActive = i === parseInt(index, 10);
          panel.classList.toggle('fc-product-tabs__panel--active', isActive);
          panel.hidden = !isActive;
        });
      }
    }
  );
}
